export default __webpack_public_path__ + "static/media/Logotipo_Bee_dark.58d6b0aa.svg";